// src/index.js
import './scss/shared.scss';

// Import your JavaScript modules
import './js/index.js';
